import React, { Component } from 'react';
import { Pagination } from "react-bootstrap";
import { CSVLink } from "react-csv";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import { PAGE_LIMIT, PARAMS } from "./config";
import { handleFieldChange } from "../../Utils";

class AdKernelHourly extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            report: [],
            total: {},
            sortParam: null,
            sortOrder: 1,
            pagesTotal: 0,
            activePage: 1,
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
    }

    componentDidMount() {
        this.loadAffids();
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === 'subid') return this.loadSubids(filters);

        this.loadReport(filters, type);
    }

    loadReport(filters) {
        API.AdKernel.getDaily(filters).then(({ report, total, quality }) => {
            const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);

            this.setState({ report, total, quality, activePage: 1, pagesTotal, isLoading: false })
        });
    }

    loadAffids() {
        this.setState({ isLoading: true })

        API.TrackerAffids.get('ak').then(affids => this.setState({ affidValues: affids, isLoading: false }))
    }

    loadSubids(filters) {
        API.AdKernel.getDaily(filters, 'subid').then(subids => {
            this.setState({ isLoading: false, subidValues: subids });
        });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getExportCsvButton() {
        let headers = PARAMS.map(([ key, label ]) => ({ key, label }));
        headers = [ { key: 'h', label: 'Hour'}, { key: 'a', label: 'Affid'}, { key: 's', label: 'Subid'}, ...headers];

        return <CSVLink data={this.state.report} headers={headers} className="btn btn-primary">Export CSV</CSVLink>;
    }

    getTable() {
        let { report, total, quality, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table report={report} total={total} quality={quality} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>
    }

    render() {
        const { isLoading, affidValues, subidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Ad Kernel Daily"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues}/>
                {this.getExportCsvButton()}

                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default AdKernelHourly;


// WEBPACK FOOTER //
// ./src/scenes/AdKernelDaily/index.js